import { Component, OnInit, Inject } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { HttpClient } from '@angular/common/http';
import { NgForm, FormGroup, FormControl, FormBuilder, Validators, ReactiveFormsModule } from '@angular/forms';

import { AuthService } from '../../services/auth.service';
import { EnvService } from '../../services/env.service';
import { CommonService } from '../../services/common.service';

import * as $ from "jquery";

@Component({
  selector: 'app-eday',
  templateUrl: './eday.component.html',
  styleUrls: ['./eday.component.css']
})
export class EdayComponent implements OnInit {

	frm : FormGroup;

	daytype:any = 1;

	passData:any = [];

	constructor(
		private http: HttpClient,
		public dialogRef: MatDialogRef<any>,
		@Inject(MAT_DIALOG_DATA) public getData,

		private env: EnvService,
		private authService: AuthService,
		private func: CommonService,
	) {
		this.frm = new FormGroup({
			ntchk: new FormControl({
				value: '',
				disabled: true
			}),
			nthour: new FormControl({
				value: '',
				disabled: true
			}),
			ntmin: new FormControl({
				value: '',
				disabled: true
			})
		});
	}

	ngOnInit() {
		if( this.getData['type'] )
		{
			this.daySel(this.getData['type']);
			this.frm.get('ntchk').setValue(this.getData['tchk']);
			this.frm.get('nthour').setValue(this.getData['thour']);
			this.frm.get('ntmin').setValue(this.getData['tmin']);
		}
	}

	async closeModal() {
		this.dialogRef.close();
	}

	async dayConfirm() {
		if( this.daytype == 2 )
		{
			if( !this.frm.get('ntchk').value )
			{
				this.func.bottomToast("오전/오후를 선택해주세요.");
				return false;
			}

			if( !this.frm.get('nthour').value )
			{
				this.func.bottomToast("시간(시)을 선택해주세요.");
				return false;
			}

			if( !this.frm.get('ntmin').value )
			{
				this.func.bottomToast("시간(분)을 선택해주세요.");
				return false;
			}
		}

		this.passData['type'] = this.daytype;
		this.passData['tchk'] = this.frm.get('ntchk').value;
		this.passData['thour'] = this.frm.get('nthour').value;
		this.passData['tmin'] = this.frm.get('ntmin').value;

		this.dialogRef.close({
			event: 'close',
			data: this.passData
		});
	}

	daySel( type ) {
		var a = type - 1;

		$(".selday-box li a").removeClass("curr");
		$(".selday-box li a i").removeClass("bi-check-circle-fill").addClass("bi-check-circle");
		$(".selday-box li:eq("+a+") a").addClass("curr");
		$(".selday-box li:eq("+a+") a i").removeClass("bi-check-circle").addClass("bi-check-circle-fill");

		this.daytype = type;

		if( type == 2 )
		{
			this.frm.get('ntchk').enable();
			this.frm.get('nthour').enable();
			this.frm.get('ntmin').enable();
		}
		else
		{
			this.frm.get('ntchk').disable();
			this.frm.get('nthour').disable();
			this.frm.get('ntmin').disable();
		}
	}
}
